import { getFaireDirectBrandAlias } from "@faire/deprecated-retailer-visitor-shared/app/_lib/data/faireDirect";
import { QueryParameters as BrandDiscountsQueryParameters } from "@faire/web-api--source/endpoints/www/api/cart/brand-discounts/get";
import { useQuery as useCartBrandDiscountsQuery } from "@faire/web-api--source/endpoints/www/api/cart/brand-discounts/get-hooks";
import { getLocation } from "@faire/web/common/globals/getLocation";
import qs from "query-string";
import { useMemo } from "react";

export const useBrandDiscounts = () => {
  const location = getLocation();
  const brandAlias = location
    ? getFaireDirectBrandAlias(location.pathname, qs.parse(location.search))
    : undefined;

  const { data, refetch, isPending } = useCartBrandDiscountsQuery(
    BrandDiscountsQueryParameters.build({
      fdb: brandAlias,
    }),
    {
      staleTime: Infinity,
      refetchOnMount: false,
    }
  );

  return useMemo(() => {
    const brandDiscounts = data?.brand_discounts ?? {};

    return { brandDiscounts, refetch, isPending };
  }, [data?.brand_discounts, refetch, isPending]);
};
